(function () {

    class GrowthBookService {
        constructor(gb) {
            this.gb = gb;
        }

        /**
         * Obtiene los atributos actuales de GrowthBook
         * @returns {Object}
         */
        getAttributes() {
            return this.gb?.getAttributes() || {};
        }

        /**
         * Actualiza un atributo en GrowthBook solo si su valor cambia
         * @param {string} key
         * @param {*} value
         */
        updateAttribute(key, value) {
            if (!this.gb) return;

            const currentAttributes = this.getAttributes();

            if (currentAttributes[key] !== value) {
                this.gb.setAttributes({
                    ...currentAttributes,
                    [key]: value
                });
            }
        }

        /**
         * Obtiene el valor de una feature desde GrowthBook
         * @param {string} feature
         * @param {*} defaultValue
         * @returns {*}
         */
        getFeatureValue(feature, defaultValue) {
            return this.gb?.getFeatureValue(feature, defaultValue);
        }
    }

    class HoldoutEvaluator {
        constructor(gbService, feature, expectedValue) {
            this.gbService = gbService;
            this.feature = feature;
            this.expectedValue = expectedValue;
            this.DEFAULT_VALUE = "exposed";
        }

        /**
         * Determina si el usuario está dentro del holdout
         * @returns {boolean}
         */
        isInHoldout() {
            if (!this.feature || !this.expectedValue) return false;

            const value = this.gbService.getFeatureValue(this.feature, this.DEFAULT_VALUE);
            return value === this.expectedValue;
        }
    }

    class ExperimentRunner {
        constructor(gbService, holdoutEvaluator) {
            this.gbService = gbService;
            this.holdoutEvaluator = holdoutEvaluator;
        }

        /**
         * Ejecuta la lógica de experimentos y actualiza atributos necesarios
         */
        run() {
            const isInHoldout = this.holdoutEvaluator.isInHoldout();
            this.gbService.updateAttribute("holdOut", isInHoldout);
        }
    }

    class GrowthBookInitializer {
        constructor() {
            this.HOLDOUT_FEATURE = window?.growthbook_settings?.holdout_feature;
            this.HOLDOUT_VALUE = window?.growthbook_settings?.holdout_value;
        }

        /**
         * Inicializa la ejecución de experimentos y escucha eventos de GrowthBook
         */
        init() {
            window.growthbook_queue = window.growthbook_queue || [];

            window.growthbook_queue.push((gb) => {
                const gbService = new GrowthBookService(gb);
                const holdoutEvaluator = new HoldoutEvaluator(
                    gbService,
                    this.HOLDOUT_FEATURE,
                    this.HOLDOUT_VALUE
                );
                const runner = new ExperimentRunner(gbService, holdoutEvaluator);

                runner.run();

                document.addEventListener("growthbookdata", (e) => {
                    e.stopPropagation();
                    e.stopImmediatePropagation();
                    runner.run();
                });
            });
        }
    }

    new GrowthBookInitializer().init();

})();